// @flow
import Spinner from 'components/Spinner'
import * as React from 'react'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import Space from 'ui/atoms/Space'
import TextField from 'ui/molecules/TextField'

import { IndependentDatetimePicker } from '../molecules/IndependentDatetimePicker'

type Props = {
  clientLabel: ?string,
  customNameInputs?: React.Node,
  customSubmitControls?: React.Node,
  dateDisabled?: boolean,
  email: string,
  setEmail: (email: string) => void,
  firstName: string,
  setFirstName: (string) => void,
  validateFirstName: () => Promise<void> | void,
  formError: ?{
    firstName?: boolean,
    lastName?: boolean,
    dateOfBirth?: boolean,
    email?: boolean,
  },
  formErrorLabel: ?{
    firstName?: ?string,
    lastName?: ?string,
    dateOfBirth?: ?string,
    email?: ?string,
  },
  lastName: string,
  setLastName: (string) => void,
  validateLastName: () => Promise<void> | void,
  teamConfig: ?{
    ask_dob: boolean,
    ask_email: boolean,
  },
  dateOfBirth: ?string,
  maxValidDate: ?Date,
  onUpdateDateOfBirth: (string) => void,
  validateDateOfBirth: () => Promise<void> | void,
  handleSubmit: () => Promise<void> | void,
  isSubmitting: boolean,
  validateEmail: () => Promise<void> | void,
}

function PatientFormContent({
  customNameInputs,
  customSubmitControls,
  clientLabel,
  dateDisabled,
  firstName,
  setFirstName,
  validateFirstName,
  formError,
  formErrorLabel,
  lastName,
  setLastName,
  validateLastName,
  teamConfig,
  validateEmail,
  dateOfBirth,
  maxValidDate,
  onUpdateDateOfBirth,
  validateDateOfBirth,
  handleSubmit,
  email,
  setEmail,
  isSubmitting,
}: Props): React.Node {
  return (
    <Space>
      {customNameInputs ? (
        customNameInputs
      ) : (
        <Flex $flexDirection="row" $horizontalSpacing="large">
          <FlexBox>
            <TextField
              errorLabel={formErrorLabel?.firstName}
              hasError={formError?.firstName}
              label={`${clientLabel ? `${clientLabel} ` : ''}First Name`}
              name="firstName"
              onBlur={validateFirstName}
              onChange={setFirstName}
              translate="no"
              value={firstName}
            />
          </FlexBox>
          <FlexBox>
            <TextField
              errorLabel={formErrorLabel?.lastName}
              hasError={formError?.lastName}
              label={`${clientLabel ? `${clientLabel} ` : ''}Last Name`}
              name="lastName"
              onBlur={validateLastName}
              onChange={setLastName}
              translate="no"
              value={lastName}
            />
          </FlexBox>
        </Flex>
      )}
      {teamConfig?.ask_dob === undefined || teamConfig?.ask_dob === true ? (
        <Flex $flexDirection="row">
          <FlexBox>
            <IndependentDatetimePicker
              semibold
              showPastOnly
              disabled={dateDisabled}
              errorLabel={formErrorLabel?.dateOfBirth}
              hasError={formError?.dateOfBirth}
              key={dateOfBirth}
              label={`${clientLabel ? `${clientLabel} ` : ''}Date of Birth`}
              maxDate={maxValidDate}
              name="person_date_of_birth"
              onBlur={validateDateOfBirth}
              onChange={(value) => onUpdateDateOfBirth(value ? value : '')}
              placeholder="Date of birth"
              translate="no"
              value={dateOfBirth}
            />
          </FlexBox>
        </Flex>
      ) : null}
      {teamConfig?.ask_email === true ? (
        <TextField
          useEvent
          errorLabel={formErrorLabel?.email}
          hasError={formError?.email}
          label={`${clientLabel ? `${clientLabel} ` : ''}Email`}
          name="person_email"
          onBlur={validateEmail}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          translate="no"
          value={email}
        />
      ) : null}
      {customSubmitControls ? (
        customSubmitControls
      ) : (
        <div className="flex justify-center">
          <Button
            $primary
            className="button-color"
            dataCy="patient-form-content-submit-button"
            onClick={handleSubmit}
            translate="no"
          >
            {isSubmitting ? <Spinner /> : 'Begin'}
          </Button>
        </div>
      )}
    </Space>
  )
}

export default PatientFormContent
